// Copyright (c) Ensho Health, 2021 to present

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducer';

export default createStore(reducers, applyMiddleware(thunk));
